/*
    Developer Name :  RAJA
    Developed Date :  03-12-2021
    Page Name      :  Item Cat Mst Service
    Created        :  03-12-2021
    Last Edited By : 
    Edited Date    : 
    Last Edited    : 
*/

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ItemCategoryApi} from '../../api/master/item-category-mst.api';
import { switchMap, map } from 'rxjs/operators';
import { ItemCategoryData,ItemCategory, ItemCreditNote  } from '../../interface/master/item-category-mst';

@Injectable()
export class ItemCategoryService extends ItemCategoryData {

  constructor(private api: ItemCategoryApi) {
    super();
  }


  list(url:string): Observable<ItemCategory[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<ItemCategory>{
      return this.api.getById(url);
  }
  create(url: string, data:ItemCategory): Observable<ItemCategory> {
    return this.api.add(url,data);
  }
  update(url: string, data:ItemCategory): Observable<ItemCategory> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }  
  //credit
  creditlist(url:string): Observable<ItemCreditNote[]> {
    return this.api.list(url);
  }
  creditcreate(url: string, data:ItemCreditNote): Observable<ItemCreditNote> {
    return this.api.creditadd(url,data);
  }
  creditupdate(url: string, data:ItemCreditNote): Observable<ItemCreditNote> {
    return this.api.creditupdate(url,data);
  }
}
